import { storeAction } from "../actionTypes";
import { Url } from "../../config/config";
import axios from "axios";
import { isLoggedIn } from "../../utils";

//------------------------------------------------STORE-PROFILE-----------------------------------------------

export const storeDetailsInitiate = () => ({
  type: storeAction.STORE_DETAILS_INITIATE,
});

export const storeDetailsSuccess = (data) => ({
  type: storeAction.STORE_DETAILS_SUCCESS,
  payload: data,
});

export const storeDetailsFailure = (data) => ({
  type: storeAction.STORE_DETAILS_FAILURE,
  payload: data,
});

export function getStore(payload = {}) {
  return (dispatch) => {
    const token = isLoggedIn("ownerLogin");
    
    // Auto-inject selectedBranchId if not present in payload and not querying by explicit store id
    const selectedBranchId = localStorage.getItem("selectedBranchId");
    const finalPayload = { ...payload };
    if (selectedBranchId && !finalPayload._id && !finalPayload.id) {
      finalPayload._id = selectedBranchId;
    }

    console.log("getStore dispatch payload:", payload, "finalPayload:", finalPayload);

    dispatch(storeDetailsInitiate(finalPayload));
    return new Promise((resolve, reject) =>
      axios
        .post(`${Url}store/storeDetails`, finalPayload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;
          console.log("getStore API response data:", data);
          if (data.status === 200) {
            dispatch(storeDetailsSuccess(data));
          } else if (data.status === 505) {
            dispatch(storeDetailsSuccess(data));
          } else {
            dispatch(storeDetailsFailure(data));
          }
          resolve(data);
        })
        .catch((err) => {
          dispatch(storeDetailsFailure(err));
          reject(err);
        })
    );
  };
}

export const setSelectedBranch = (branchId, branchName) => ({
  type: storeAction.SET_SELECTED_BRANCH,
  payload: { branchId, branchName }
});

//------------------------------------------------STORE-UPLOAD-----------------------------------------------

export const storeUploadInitiate = () => ({
  type: storeAction.STORE_UPLOAD_INITIATE,
});

export const storeUploadSuccess = (data) => ({
  type: storeAction.STORE_UPLOAD_SUCCESS,
  payload: data,
});

export const storeUploadFailure = (data) => ({
  type: storeAction.STORE_UPLOAD_FAILURE,
  payload: data,
});

export function getStoreUpload(payload) {
  return (dispatch) => {
    const token = isLoggedIn("ownerLogin");
    dispatch(storeUploadInitiate(payload));
    return new Promise((resolve, reject) =>
      axios
        .post(`${Url}store/updateStore`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;

          if (data.status === 200) {
            dispatch(storeUploadSuccess(data));
          } else {
            dispatch(storeUploadFailure(data));
          }
          resolve(data);
        })
        .catch((err) => {
          dispatch(storeUploadFailure(err));
          reject(err);
        })
    );
  };
}

//====================CHNAGE-PAYEMENT----STATUS========================

export const changePaymentStatusInitate = () => ({
  type: storeAction.CHANGE_PAYMENT_STATUS_INITIATE,
});

export const changePaymentStatusSuccess = (data) => ({
  type: storeAction.CHANGE_PAYMENT_STATUS_SUCCESS,
  payload: data,
});

export const changePaymentStatusFailure = (data) => ({
  type: storeAction.CHANGE_PAYMENT_STATUS_FAILURE,
  payload: data,
});

export function changePaymentStatus(payload) {
  const token = isLoggedIn("ownerLogin");
  return (dispatch) => {
    dispatch(changePaymentStatusInitate());
    return new Promise((resolve, reject) => {
      axios
        .post(`${Url}store/changeOrderStatus`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          if (response.status === 200) {
            dispatch(changePaymentStatusSuccess(response.data));
            resolve(response.data);
          } else {
            dispatch(changePaymentStatusFailure(response.data));
            reject(response.data);
          }
        })
        .catch((err) => {
          dispatch(changePaymentStatusFailure(err));
          reject(err);
        });
    });
  };
}
